import { I18nProvider } from '@refinedev/core';

import { useTranslation } from 'react-i18next';

const useI18nProvider = () => {
  const { t, i18n } = useTranslation();

  const i18nProvider: I18nProvider = {
    translate: (key: string, options?: any): string => t(key, options) as string,
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };
  return i18nProvider;
};

export default useI18nProvider;
